import React from "react";

function Details() {
  return (
    <div className="page">
      <section className="section section-light fade-up">
        <div className="section-inner">
          <h2>Wedding Details</h2>
          <p className="section-intro">
            All the information you need to join us for our special day.
          </p>

          <div className="details-grid">
            <div className="details-card">
              <h3>Ceremony</h3>
              <p className="details-time">Saturday, September 19, 2026 • 4:00 PM</p>
              <p>Collective Spaces</p>
              <p>306 W Redwood St Suite 500</p>
              <p>Baltimore, MD 21201</p>
            </div>

            <div className="details-card">
              <h3>Reception</h3>
              <p className="details-time">Saturday, September 19, 2026 • 7:00 PM</p>
              <p>5 Starr Events Hall</p>
              <p>728 Main St</p>
              <p>Reisterstown, MD 21208</p>
            </div>

            <div className="details-card">
              <h3>Dress Code</h3>
              <p>Formal / Cocktail Attire</p>
              <p>Women: Knee-length or longer dresses</p>
              <p>Men: Tuxedos or Formal Suits.</p>
              <p>Kindly avoid wearing white (that's reserved for the bride)!</p>
            </div>
          </div>

          <div className="map-note">
            <p>
              We will share detailed parking information and recommended hotels
              here closer to the date.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Details;
